import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/It-Services-Components/Footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";
import icon from "../../images/icon/magic.svg";
import gImg1 from "../../images/logo/moving_1.png";
import gImg2 from "../../images/logo/moving_2.png";
import gImg3 from "../../images/logo/moving_3.png";
import gImg4 from "../../images/logo/moving_4.png";
import gImg5 from "../../images/logo/moving_1.png";
import gImg6 from "../../images/logo/moving_2.png";
import Header2 from "../../components/Header2/Header2";

const TermsPage = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header2 />
        <section
          className="page-title cp-page-title pt-200 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap">
              <div className="row mt-none-30 align-items-center">
                <div className="col-lg-8 mt-30">
                  <div className="page-title-box">
                    <span className="sub-title">
                      <img src={icon} alt="" />
                      Terms & Conditions
                    </span>
                    <h2 className="title">
                      Anantkamal – Website Terms & Conditions of Use
                    </h2>
                    <span className="page-update_time">
                      Updated on : July 19th, 2025
                    </span>
                  </div>
                </div>
                <div className="col-lg-4 mt-30">
                  <div className="cp-img-slide">
                    <div className="cp-img-inner ul_li">
                      <div className="cp-item marquee-first">
                        <div className="xb-img">
                          <img src={gImg1} alt="" />
                        </div>
                        <div className="xb-img">
                          <img src={gImg2} alt="" />
                        </div>
                        <div className="xb-img">
                          <img src={gImg3} alt="" />
                        </div>
                        <div className="xb-img">
                          <img src={gImg1} alt="" />
                        </div>
                        <div className="xb-img">
                          <img src={gImg2} alt="" />
                        </div>
                        <div className="xb-img">
                          <img src={gImg3} alt="" />
                        </div>
                      </div>
                      <div className="cp-item marquee-2">
                        <div className="xb-img">
                          <img src={gImg4} alt="" />
                        </div>
                        <div className="xb-img">
                          <img src={gImg5} alt="" />
                        </div>
                        <div className="xb-img">
                          <img src={gImg6} alt="" />
                        </div>
                        <div className="xb-img">
                          <img src={gImg4} alt="" />
                        </div>
                        <div className="xb-img">
                          <img src={gImg5} alt="" />
                        </div>
                        <div className="xb-img">
                          <img src={gImg6} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="terms&conditions-section cp-det-bg">
          <div className="container">
            <div className="terms-section_inner pt-120 pb-75">
              <div className="row">
                <div className="col-lg-11">
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Copyright and intellectual property usage
                    </h2>
                    <p>
                      All content on this website — including text, graphics,
                      logos, designs, and trademarks — is the intellectual
                      property of Anantkamal and is protected under copyright,
                      trademark, and related intellectual property laws. You may
                      not use, reproduce, republish, download, transmit,
                      distribute, modify, rent, loan, sell, license, or create
                      derivative works from any material on this site without
                      our prior written consent.
                    </p>
                    <p>
                      Images on this website may include licensed stock photos,
                      to which Anantkamal does not claim copyright ownership.
                      All other trademarks and trade names are the properties of
                      their respective owners.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Website usage terms
                    </h2>
                    <p>
                      By using this website, you agree to the following terms of
                      use. Please read them carefully to ensure a respectful and
                      lawful experience for all users.
                    </p>
                    <p>
                      All content on this site—including text, images, graphics,
                      videos, and audio—is protected by intellectual property
                      laws. You may not copy, modify, republish, or redistribute
                      any material for commercial or public use without prior
                      written permission from Anantkamal. Unauthorized use may
                      lead to legal consequences.
                    </p>
                    <p>
                      We value a safe and respectful online environment. Users
                      are prohibited from submitting or sharing content that is
                      unlawful, harmful, defamatory, harassing, or otherwise
                      inappropriate through this website. Misusing contact
                      details (such as email addresses) listed on this site for
                      spam, promotions, or unsolicited communication is strictly
                      prohibited.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Software and services
                    </h2>
                    <p>
                      Our software and services are provided on an “as-is” and
                      “as-available” basis. By choosing to use our services, you
                      agree to enter into a legally binding agreement that
                      outlines the specific terms and conditions of service. To
                      begin using any of our solutions, your explicit consent is
                      required—ensuring mutual understanding and agreement
                      between you (the client) and Anantkamal. This helps us
                      maintain transparency, accountability, and a high standard
                      of service delivery.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Personal information policy
                    </h2>
                    <p>
                      At Anantkamal, we respect your privacy and are committed
                      to handling your personal information responsibly. We
                      follow ethical business practices and take necessary
                      measures to protect your data. All personal details shared
                      with us are managed in accordance with our Privacy Policy,
                      which outlines how we collect, use, store, and protect
                      your information. We encourage you to review it carefully
                      to understand your rights and our responsibilities.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">Disclaimer</h2>
                    <p>
                      The information on this website is shared in good faith
                      and sourced from what we believe to be reliable providers.
                      However, it may occasionally include errors or
                      inaccuracies. Anantkamal makes no guarantees—express or
                      implied—regarding the accuracy, completeness, or
                      reliability of the content, services, or products
                      presented. Nothing on this site should be interpreted as
                      professional advice. We specifically disclaim all
                      warranties, including those related to merchantability or
                      fitness for a particular purpose. Any use of content or
                      services from this site is entirely at your own risk.
                      Anantkamal is not liable for any direct, indirect,
                      incidental, or consequential damages arising from your
                      use—or inability to use—this website or its contents. By
                      using the site, you agree to indemnify and hold Anantkamal
                      harmless against any claims, losses, damages, or legal
                      fees resulting from misuse or violation of these terms.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">
                      Limitation of liability
                    </h2>
                    <p>
                      To the fullest extent permitted by law, Anantkamal shall
                      not be held liable for any damages arising from the use of
                      this website or our services—including, but not limited
                      to, loss of data, revenue, or profits—regardless of
                      whether such damages were foreseeable or if we were
                      advised of the possibility in advance. Please note, some
                      jurisdictions do not allow the exclusion or limitation of
                      liability for certain types of damages. In such cases, our
                      liability is limited to the maximum extent permitted by
                      applicable law.
                    </p>
                  </div>
                  <div className="item-details-widget">
                    <h2 className="item_details_info_title">Contact</h2>
                    <p>
                      <Link
                        onClick={ClickHandler}
                        to="/contact"
                        className="details-link"
                      >
                        Click here
                      </Link>
                      to contact us regarding this Terms & Conditions or other
                      related issues. You can also send us an e-mail <br /> on: 
                      <a href="mailto:contact@anantkamal.com">
                        contact@anantkamal.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <CtaSection cClass={"bg"} />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default TermsPage;
